import React, { useEffect, useState } from 'react'
import Autosuggest, { InputProps, SuggestionsFetchRequestedParams, SuggestionSelectedEventData } from 'react-autosuggest'
import './AutoComplete.scss'

interface Props {
  defaultValue?: string
  suggestionList: string[]
  onSelect: (label: string, value: string) => void
}

function getSuggestionValue (suggestion: string) {
  return suggestion
}

function renderSuggestion (suggestion: string) {
  return <span>{suggestion}</span>
}

function getSuggestions (value: string, suggestionList: string[]) {
  const escapedValue = escapeRegexCharacters(value.trim())
  if (escapedValue === '') {
    return []
  }
  const regex = new RegExp('^' + escapedValue, 'i')
  return suggestionList.filter(list => regex.test(list))
}

function escapeRegexCharacters (str: string) {
  return str.replace(/[.*+?^${}()|[\\]\\]/g, '\\$&')
}

const AutoComplete: React.FC<Props> = ({ defaultValue = '', suggestionList = [], onSelect }) => {
  const [value, setValue] = useState('')
  const [suggestions, setSuggestions] = useState<string[]>([])
  const [floatingClass, setfloatingClass] = useState('')
  const [hasError, setError] = useState(false)

  const onChange = (event: React.FormEvent<HTMLInputElement>, params: { newValue: string }) => {
    setValue(params.newValue)
    if (params.newValue !== '') {
      setfloatingClass('valid-float')
    } else {
      setfloatingClass('')
    }
    setError(params.newValue.length < 2)
    onSelect(defaultValue, params.newValue)
  }

  const inputProps: InputProps<string> = {
    value,
    onChange
  }

  const onSuggestionsFetchRequested = ({ value }: SuggestionsFetchRequestedParams) => {
    if (value?.length >= 2) {
      setSuggestions(getSuggestions(value, suggestionList))
    } else {
      setSuggestions([])
    }
  }

  const onSuggestionsClearRequested = () => {
    setSuggestions([])
  }

  const getSelectedValue = (event: React.FormEvent, data: SuggestionSelectedEventData<string>) => {
    const { suggestionValue } = data
    setValue(suggestionValue)
    setfloatingClass('valid-float')
    onSelect(defaultValue, suggestionValue)
  }

  return (
    <>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={getSelectedValue}
        inputProps={inputProps}
      />
      <span className={`floating-autosuggest ${floatingClass}`}>{'Customer Name'}</span>
      {hasError && <span className='customer-validation'>{'Enter atleast 2 characters to search for a customer'}</span>}
    </>
  )
}

export default AutoComplete
